import router from '../../router'

export interface Tickets {
  amount: number
  benefit: string
  created_at: string
  description: string
  email: string
  feature: string
  holder: string
  holder_image: {
    id: string
    url: string
  }
  holder_name: string
  id: string
  message: string
  name: string
  org: string
  profile_image: {
    id: string
    url: string
  }
  state: string
  transaction: string
  updated_at: string
}

export interface State {
  tickets: {
    next_offset: number
    tickets: Tickets[]
  } | null
  ticketId: string
  isTicketsLoading: boolean
  usedAt: string
  isUsedComplete: boolean
}

export interface Context {
  commit: (name: string, payload: object) => void
  dispatch: (name: string, payload?: any, options?: any) => void
}

export interface Mutations {
  [key: string]: (state: State, payload?: any) => void
}

export interface Actions {
  [key: string]: (this: any, context: Context, payload?: any) => void
}

export const initialState: State = {
  tickets: null,
  ticketId: '',
  usedAt: '',
  isTicketsLoading: false,
  isUsedComplete: false
}

export const mutations: Mutations = {
  setTickets(state, payload) {
    state.tickets = payload
  },
  setTicketId(state, payload) {
    state.ticketId = payload.id
  },
  setTicketUsedAt(state, payload) {
    state.usedAt = payload.usedAt
  },
  onTicketsLoadingStart(state) {
    state.isTicketsLoading = true
  },
  onTicketsLoadingFinished(state) {
    state.isTicketsLoading = false
  },
  toggleUsedTickets(state, payload) {
    state.isUsedComplete = payload.value
  }
}

export const actions: Actions = {
  async fechTickets({ commit }) {
    commit('onTicketsLoadingStart', {})
    const { response, error } = await this.$api.fetchTickets()
    if (response) {
      commit('setTickets', response)
      await this.$delay(500)
      commit('onTicketsLoadingFinished', {})
      return
    }
    await this.$delay(500)
    commit('onTicketsLoadingFinished', {})
  },
  async postTickets({ commit, dispatch }, payload) {
    commit('onTicketsLoadingStart', {})
    const { response, error } = await this.$api.postTickets(payload)
    if (response) {
      await this.$delay(500)
      dispatch(
        'flash/setMessage',
        {
          message: '特典の交換が完了しました',
          isAlert: false
        },
        {
          root: true
        }
      )
      commit('onTicketsLoadingFinished', {})
      router.push('/items')
      return
    }
    await this.$delay(500)
    commit('onTicketsLoadingFinished', {})
  },
  async postTicketsUse({ commit }, payload) {
    commit('onTicketsLoadingStart', {})
    const { response, error } = await this.$api.postTicketsUse(payload)
    if (response) {
      commit('toggleUsedTickets', { value: true })
      await this.$delay(500)
      commit('onTicketsLoadingFinished', {})
      return
    }
    await this.$delay(500)
    commit('onTicketsLoadingFinished', {})
  },
  async closeUsedTickets({ commit }) {
    commit('toggleUsedTickets', { value: false })
  },
  async setTicketId({ commit }, payload) {
    commit('setTicketId', payload)
  },
  async setTicketUsedAt({ commit }, payload) {
    commit('setTicketUsedAt', payload)
  }
}

export default {
  namespaced: true,
  state: () => initialState,
  mutations,
  actions
}
